export default "__VITE_ASSET__Cdjxx1vx__"